module.exports = __webpack_public_path__ + "img/class-banner_bg.5c8fd7f.webp";